export default __webpack_public_path__ + "static/media/bronze.8bd6caa1.png";